const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;

const group = {
  elements: [],
  version: 'v1',
  type: 'group',
  collapsed: false,
  locked: false,
  name: 'Group',
  cssClasses: '',
  animation: false,
  animationInStyle: 'fadeIn',
  animationInDuration: 750,
  animationInDelay: 0,
  animationInEasing: '0.250, 0.100, 0.250, 1.000',
  animationOutStyle: 'fadeOut',
  animationOutDuration: 750,
  animationOutDelay: 0,
  animationOutEasing: '0.250, 0.100, 0.250, 1.000',
  loopingAnimation: false,
  loopingAnimationStyle: 'flipInOut',
  loopingAnimationDuration: 800,
  loopingAnimationDelay: 5000,
  loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
  blur: false,
  blurSize: 10,
  border: false,
  borderWidth: 2,
  borderColor: '#000000',
  boxShadow: false,
  boxShadowX: 1,
  boxShadowY: 2,
  boxShadowBlur: 4,
  boxShadowSpread: 0,
  boxShadowColor: '#000000',
  dropShadow: false,
  fillStyle: 'solid',
  backgroundColor: '#FFFFFF',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
  gradientDirection: 180,
  gradientColorOne: '#00c4dd',
  gradientColorTwo: '#0f84fb',
  backgroundImage: false,
  backgroundImageUrl: '',
  background: false,
  styles: {
    top: 0,
    left: 0,
    width: 720,
    height: 400,
    opacity: 1,
  },
};

const marqueeText = {
  type: 'marquee-text',
  name: 'Ticker Text',
  editable: true,
  text: 'Edit the text in the right side bar.',
  disableResize: true,
  locked: false,
  fixedChild: true,
  cssClasses: '',
  textShadow: false,
  textShadowX: 1,
  textShadowY: 2,
  textShadowBlur: 4,
  textShadowColor: '#000000',
  fillStyle: 'solid',
  backgroundColor: '#000000',
  gradientDirection: 180,
  gradientColorOne: '#00c4dd',
  gradientColorTwo: '#0f84fb',
  background: false,
  boxShadow: false,
  boxShadowX: 1,
  boxShadowY: 2,
  boxShadowBlur: 4,
  boxShadowSpread: 0,
  boxShadowColor: '#000000',
  dropShadow: false,
  styles: {
    color: '#ffffff',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    textTransform: 'none',
    textDecoration: 'none',
    fontSize: 40,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: 1, // everything is a single line for now, so this doesn't really matter
  },
};

const marqueeImage = {
  type: 'marquee-image',
  name: 'Ticker Image',
  editable: true,
  locked: false,
  disableResize: true,
  imageUrl: `${TGB_ASSETS_URL}/placeholders/placeholder-square.svg`,
  aspectLock: true,
  fixedParent: true,
  background: false,
  border: false,
  borderWidth: 2,
  borderColor: '#000000',
  boxShadow: false,
  boxShadowX: 1,
  boxShadowY: 2,
  boxShadowBlur: 4,
  boxShadowSpread: 0,
  boxShadowColor: '#000000',
  dropShadow: false,
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  borderBottomRightRadius: 0,
  borderBottomLeftRadius: 0,
  blur: false,
  blurSize: 10,
  skewX: 0,
  skewY: 0,
  rotate: 0,
  flipX: false,
  flipY: false,
  styles: {
    width: 50,
    height: 50,
    opacity: 1,
  },
};

const text = {
  version: 'v2',
  type: 'text',
  editable: true,
  name: 'Text',
  locked: false,
  text: 'Double click to edit',
  cssClasses: '',
  animation: false,
  animationInStyle: 'fadeIn',
  animationInDuration: 750,
  animationInDelay: 0,
  animationInEasing: '0.250, 0.100, 0.250, 1.000',
  animationOutStyle: 'fadeOut',
  animationOutDuration: 750,
  animationOutDelay: 0,
  animationOutEasing: '0.250, 0.100, 0.250, 1.000',
  loopingAnimation: false,
  loopingAnimationStyle: 'flipInOut',
  loopingAnimationDuration: 800,
  loopingAnimationDelay: 5000,
  loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
  textShadow: false,
  textShadowX: 1,
  textShadowY: 2,
  textShadowBlur: 4,
  textShadowColor: '#000000',
  fitText: false,
  limitCharacters: false,
  maxCharacterLength: 0,
  ticker: false,
  tickerCrawlSpeed: 2000,
  fillStyle: 'solid',
  backgroundColor: '#00c4dd',
  gradientDirection: 180,
  gradientColorOne: '#00c4dd',
  gradientColorTwo: '#0f84fb',
  background: false,
  verticalAlign: 'top',
  maxSizeText: false,
  skewX: 0,
  skewY: 0,
  rotate: 0,
  styles: {
    top: 515,
    left: 660,
    width: 600,
    height: 50,
    opacity: 1,
    color: '#000000',
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    textTransform: 'none',
    textDecoration: 'none',
    fontSize: 40,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    lineHeight: 1.25,
    textAlign: 'left',
    textBoxOption: 1,
    textFlowOption: 1,
    maxSizeText: 0,
  },
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
};

const defaults = {
  template: {
    /*
     * If you add something, make sure to bump the minor version number.
     * There is code to make sure the new things get added to the template
     * payload when a user opens up a pre-existing graphic.
     */
    version: 'v1.3',
    owner: null,
    _id: null,
    title: 'Untitled',
    snippets: [],
    tags: [],
    canvas: {
      width: 1920,
      height: 1080,
    },
    safeArea: {
      show: false,
      width: 90,
      height: 90,
    },
    elements: [],
    guides: {
      show: false,
      hGuides: [],
      vGuides: [],
    },
  },

  'sheet-data': {
    editable: true,
    version: 'v1.0',
    elements: [],
    type: 'sheet-data',
    name: 'Google Sheet',
    collapsed: false,
    locked: false,
    data: {},
    settings: {},
  },

  'social-data': {
    elements: [],
    version: 'v1.1',
    type: 'social-data',
    name: 'Social Data',
    collapsed: false,
    locked: false,
    editable: true, // this allows us to have editable settings in producer
    cycleSpeed: 15e3,
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    postSettings: {
      showOtherLinks: false,
      globalLinkColor: true,
      removeSpaces: false,
      linkStyles: {
        link: {
          color: '#2bacca',
        },
        mention: {
          color: '#2bacca',
        },
        hashtag: {
          color: '#2bacca',
        },
        cashtag: {
          color: '#2bacca',
        },
      },
    },
  },

  sportradar: {
    version: 'v2.0',
    type: 'sportradar',
    name: 'Sports Data',
    elements: [],
    collapsed: false,
    locked: false,
    editable: true, // this allows us to have editable settings in producer
    data: {
      controlOptions: {},
    },
  },

  'linked-data': {
    type: 'linked-data',
    name: 'Linked',
    elements: [],
    collapsed: false,
    locked: true,
    editable: false,
    visible: true,
  },

  group,

  'data-list': {
    ...group,
    type: 'data-list',
    name: 'Dynamic List',
    editable: true,
    data: {
      range: '',
      filters: [
        {
          type: 'pagination',
          offset: 1, // Start from item... (index + 1)
          page: 1, // Page number (index + 1)
          limit: 10, // Items per page
        },
      ],
    },
    settings: {
      gap: 0,
      layout: 'column',
    },
  },

  text,

  textsvg: {
    version: 'v1',
    type: 'text-svg',
    editable: true,
    name: 'Text',
    locked: false,
    text: ['Double click to edit'],
    cssClasses: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    textShadow: false,
    textShadowX: 1,
    textShadowY: 2,
    textShadowBlur: 4,
    textShadowColor: '#000000',
    fitText: false,
    ticker: false,
    tickerCrawlSpeed: 2000,
    fillStyle: 'solid',
    backgroundColor: '#00c4dd',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    background: false,
    verticalAlign: 'top',
    styles: {
      top: 515,
      left: 660,
      viewBoxX: 0,
      viewBoxY: 0,
      width: 745,
      height: 50,
      opacity: 1,
      color: '#000000',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
      textTransform: 'none',
      textDecoration: 'none',
      fontSize: 40,
      fontWeight: 'normal',
      fontStyle: 'normal',
      letterSpacing: 0,
      textAlign: 'left',
    },
    svgStyles: {
      fill: '#000000',
      stroke: '#000000',
      strokeWidth: 0,
      strokeDasharray: 'none',
      strokeLinecap: 'butt',
      strokeLinejoin: 'miter',
      strokeMiterlimit: 4,
      strokeDashoffset: 0,
      strokeOpacity: 1,
      fillOpacity: 1,
      opacity: 1,
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
      fontSize: 40,
      fontWeight: 'normal',
      fontStyle: 'normal',
      letterSpacing: 0,
      textAlign: 'left',
      textDecoration: 'none',
      textTransform: 'none',
      textAnchor: 'start',
      dominantBaseline: 'hanging',
      baselineShift: 0,
      direction: 'ltr',
      unicodeBidi: 'normal',
      wordSpacing: 0,
      writingMode: 'lr-tb',
      glyphOrientationVertical: 'auto',
      glyphOrientationHorizontal: '0deg',
      kerning: 0,
      textLength: 0,
      textRendering: 'auto',
      fillRule: 'nonzero',
      colorInterpolation: 'sRGB',
      colorInterpolationFilters: 'linearRGB',
      floodOpacity: 1,
      floodColor: '#000000',
      lightingColor: '#ffffff',
      stopColor: '#000000',
      stopOpacity: 1,
      pointerEvents: 'visiblePainted',
      colorRendering: 'auto',
      imageRendering: 'auto',
      shapeRendering: 'auto',
      vectorEffect: 'none',
    },
  },

  image: {
    version: 'v1',
    type: 'image',
    name: 'Image',
    editable: true,
    locked: false,
    aspectLock: false,
    mask: false,
    maskShape: 'oval',
    maskPosition: 'center-center',
    imageUrl: '',
    cssClasses: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    fillType: 'fit',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    skewX: 0,
    skewY: 0,
    rotate: 0,
    flipX: false,
    flipY: false,
    styles: {
      top: 0,
      left: 0,
      width: 720,
      height: 400,
      opacity: 1,
    },
  },

  video: {
    version: 'v1',
    type: 'video',
    name: 'Video',
    editable: true,
    locked: false,
    aspectLock: true,
    src: '',
    cssClasses: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    styles: {
      top: 0,
      left: 0,
      width: 720,
      height: 400,
      opacity: 1,
    },
    duration: 0,
    contentType: undefined,
    videoOptions: {
      autoplay: true,
      loop: false,
      muted: true,
      playing: true,
      preload: 'auto',
      start: 0,
      end: false,
    },
  },

  'multi-media': {
    version: 'v1',
    type: 'multi-media',
    name: 'Media',
    isVideo: false,
    network: null,
    videoOptions: {
      autoplay: true,
      loop: true,
      muted: false,
      poster: null,
    },
    editable: false, // do we need this for social?
    locked: false,
    aspectLock: true,
    mask: false,
    maskShape: 'rectangle',
    src: '',
    cssClasses: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    fillType: 'fit',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    fillStyle: 'solid',
    backgroundColor: 'transparent',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    styles: {
      top: 0,
      left: 0,
      width: 720,
      height: 400,
      opacity: 1,
    },
  },

  rectangle: {
    version: 'v1',
    type: 'rectangle',
    name: 'Rectangle',
    locked: false,
    aspectLock: false,
    cssClasses: '',
    animation: false,
    editable: true,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    skewX: 0,
    skewY: 0,
    rotate: 0,
    styles: {
      top: 465,
      left: 885,
      width: 150,
      height: 150,
      opacity: 1,
    },
  },

  triangle: {
    version: 'v1',
    type: 'triangle',
    name: 'Triangle',
    locked: false,
    aspectLock: false,
    cssClasses: '',
    animation: false,
    editable: true,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    skewX: 0,
    skewY: 0,
    rotate: 0,
    styles: {
      top: 465,
      left: 885,
      width: 150,
      height: 150,
      opacity: 1,
    },
  },

  oval: {
    version: 'v1',
    type: 'oval',
    name: 'Oval',
    locked: false,
    aspectLock: false,
    cssClasses: '',
    animation: false,
    editable: true,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    fillStyle: 'solid',
    backgroundColor: '#0F84FB',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    styles: {
      top: 465,
      left: 885,
      width: 150,
      height: 150,
      opacity: 1,
    },
  },

  slideshow: {
    elements: [],
    entries: [],
    version: 'v1',
    editable: true,
    type: 'slideshow',
    collapsed: false,
    locked: false,
    name: 'Slideshow',
    cssClasses: '',
    cycleTime: 5000,
    hasProgressIndicator: false,
    progressIndicator: {
      type: 'progress-bar',
      progressIndicatorStyle: 'stories',
      barBackgroundColor: '#757575',
      barFillColor: '#ffffff',
      styles: {
        top: 465,
        left: 885,
        width: 400,
        height: 10,
      },
    },
    styles: {
      top: 0,
      left: 0,
    },
  },

  date: {
    version: 'v1',
    type: 'date',
    editable: true,
    name: 'Date/Time',
    locked: false,
    format: 'EEEE MMMM do, yyyy',
    customFormat: false,
    customFormatStyle: 'EEEE MMMM do, yyyy',
    customTimeZone: false,
    customTimeZoneOffset: '-8',
    customTimeZoneName: '(GMT-08:00) Pacific Time (US & Canada)',
    customTimeZoneHasDaylightSavings: 1,
    cssClasses: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    textShadow: false,
    textShadowX: 1,
    textShadowY: 2,
    textShadowBlur: 4,
    textShadowColor: '#000000',
    fitText: true,
    verticalAlign: 'top',
    skewX: 0,
    skewY: 0,
    rotate: 0,
    styles: {
      top: 515,
      left: 660,
      width: 600,
      height: 50,
      opacity: 1,
      color: '#000000',
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
      textTransform: 'none',
      textDecoration: 'none',
      fontSize: 40,
      fontWeight: 'normal',
      fontStyle: 'normal',
      letterSpacing: 0,
      textAlign: 'left',
    },
  },

  qrcode: {
    version: 'v1',
    type: 'qrcode',
    name: 'QR Code',
    editable: true,
    aspectLock: true,
    locked: false,
    cssClasses: '',
    dotColor: '#ffffff',
    backgroundColor: '#000000',
    permalink: 'https://tagboard.com',
    hasLogo: false,
    logoUrl: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    styles: {
      top: 465,
      left: 885,
      width: 200,
      height: 200,
      opacity: 1,
    },
  },

  timer: {
    version: 'v1',
    type: 'timer',
    editable: true,
    name: 'Timer',
    locked: false,
    timerType: 'Countdown',
    timerFormat: 'Hours, minutes, seconds',
    counterFormat: 'Time', // for countdown & count up
    hourPreview: 0,
    minutePreview: 0,
    secondPreview: 0,
    cutoff: false,
    cutoffTime: 0,
    style: 'Basic',
    flipClockColor: '#FFF',
    showUnits: true,
    showEndDateTime: true,
    showDays: false,
    showHours: true,
    showMinutes: true,
    showSeconds: true,
    showMilliseconds: false,
    showDividers: true,
    endDateTimeFormat: 'DD/MM/YYYY hh:mm a',
    daysLabel: 'Days',
    hoursLabel: 'Hours',
    minutesLabel: 'Minutes',
    secondsLabel: 'Seconds',
    dateTime: null,
    playTimer: false, // producer
    play: false, // graphics
    cssClasses: '',
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    textShadow: false,
    textShadowX: 1,
    textShadowY: 2,
    textShadowBlur: 4,
    textShadowColor: '#000000',
    skewX: 0,
    skewY: 0,
    rotate: 0,
    gap: 0,
    styles: {
      top: 515,
      left: 660,
      width: 600,
      height: 50,
      timerText: {
        opacity: 1,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        fontSize: 40,
        fontWeight: 'normal',
        fontStyle: 'normal',
        color: '#000000',
        letterSpacing: 0,
        lineHeight: 1,
      },
      unitText: {
        opacity: 1,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        fontSize: 40,
        fontWeight: 'normal',
        fontStyle: 'normal',
        color: '#000000',
        letterSpacing: 0,
        textTransform: 'none',
        lineHeight: 1,
      },
      endDateText: {
        opacity: 1,
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
        fontSize: 40,
        fontWeight: 'normal',
        fontStyle: 'normal',
        color: '#000000',
        letterSpacing: 0,
        lineHeight: 1,
        textTransform: 'none',
      },
    },
  },

  marquee: {
    version: 'v1',
    type: 'marquee', // not using ticker because of class conflicts with legacy text element ticker
    editable: true,
    name: 'Advanced Ticker',
    locked: false,
    speed: 2000, // in milliseconds 500 - 4000
    reverse: false,
    fillStyle: 'solid',
    backgroundColor: '#000000',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    background: true,
    verticalAlign: 'middle',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    fillType: 'fit',
    tickerSpacing: 'infinite', // infinite, spaced (div animates full width before repeating or repeats at end of div)
    animation: false,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    elements: [],
    styles: {
      gap: 16,
      top: 945,
      left: 0,
      width: 600,
      height: 80,
      opacity: 1,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
  },

  shoppable: {
    ...group,
    version: 'v1',
    type: 'shoppable',
    name: 'Shoppable',
    editable: true,
    locked: false,
    elements: [],
    data: {},
    styles: {
      ...group.styles,
      top: 50,
      left: 50,
    },
  },

  frame: {
    version: 'v1',
    type: 'frame',
    name: 'Browser Source',
    locked: false,
    aspectLock: false,
    cssClasses: '',
    animation: false,
    editable: true,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    fillStyle: 'solid',
    backgroundColor: '#000000',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    skewX: 0,
    skewY: 0,
    rotate: 0,
    styles: {
      top: 0,
      left: 0,
      width: 400,
      height: 600,
      opacity: 1,
    },
    url: 'https://tagboard.com',
    isExperience: false,
  },

  'social-display': {
    version: 'v1',
    type: 'social-display',
    name: 'Social Graphic',
    locked: false,
    aspectLock: false,
    cssClasses: '',
    animation: false,
    editable: true,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    fillStyle: 'solid',
    backgroundColor: 'transparent',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    skewX: 0,
    skewY: 0,
    rotate: 0,
    styles: {
      top: 0,
      left: 0,
      width: 1920,
      height: 1080,
      opacity: 1,
    },
    displayId: null,
    layout: null,
    isSocialDisplay: true,
    previewTagboardId: '396837',
  },

  'poll-display': {
    version: 'v1',
    type: 'poll-display',
    name: 'Poll Graphic',
    locked: false,
    aspectLock: false,
    cssClasses: '',
    animation: false,
    editable: true,
    animationInStyle: 'fadeIn',
    animationInDuration: 750,
    animationInDelay: 0,
    animationInEasing: '0.250, 0.100, 0.250, 1.000',
    animationOutStyle: 'fadeOut',
    animationOutDuration: 750,
    animationOutDelay: 0,
    animationOutEasing: '0.250, 0.100, 0.250, 1.000',
    loopingAnimation: false,
    loopingAnimationStyle: 'flipInOut',
    loopingAnimationDuration: 800,
    loopingAnimationDelay: 5000,
    loopingAnimationEasing: '0.250, 0.100, 0.250, 1.000',
    border: false,
    borderWidth: 2,
    borderColor: '#000000',
    boxShadow: false,
    boxShadowX: 1,
    boxShadowY: 2,
    boxShadowBlur: 4,
    boxShadowSpread: 0,
    boxShadowColor: '#000000',
    dropShadow: false,
    fillStyle: 'solid',
    backgroundColor: 'transparent',
    backgroundSize: 'contain',
    backgroundPosition: 'center center',
    gradientDirection: 180,
    gradientColorOne: '#00c4dd',
    gradientColorTwo: '#0f84fb',
    backgroundImage: false,
    backgroundImageUrl: '',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    blur: false,
    blurSize: 10,
    skewX: 0,
    skewY: 0,
    rotate: 0,
    styles: {
      top: 0,
      left: 0,
      width: 1920,
      height: 1080,
      opacity: 1,
    },
    displayId: null,
    pollId: null,
    isPollDisplay: true,
    currentRoundIndex: 0,
    currentDisplayState: 'results',
    currentQuestionIndex: 0,
  },

  'marquee-text': marqueeText,
  'marquee-image': marqueeImage,
};

export default defaults;
